const grade_8= {
    label: "Grade 8",
    subjects: {
 "applied_design_8": {
    "label": "Applied Design (Grade 8)",
    "topics": [
      { "value": "Understanding_Context", "label": "Understanding Context" },
      { "value": "defining", "label": "Defining" },
      { "value": "ideating", "label": "Ideating" },
      { "value": "prototyping", "label": "Prototyping" },
      { "value": "testing", "label": "Testing" },
      { "value": "making", "label": "Making" },
      { "value": "sharing", "label": "Sharing" },
      { "value": "applied_skills", "label": "Applied Skills" },
      { "value": "applied_technologies", "label": "Applied Technologies" }
    ],
    "competencies": {
      "core": [
      { "value": "Understanding_Context", "label": "Understanding Context" },
      { "value": "defining", "label": "Defining" },
      { "value": "ideating", "label": "Ideating" },
      { "value": "prototyping", "label": "Prototyping" },
      { "value": "testing", "label": "Testing" },
      { "value": "making", "label": "Making" },
      { "value": "sharing", "label": "Sharing" },
      { "value": "applied_skills", "label": "Applied Skills" },
      { "value": "applied_technologies", "label": "Applied Technologies" }
      ],
    "sub": {
        "applied_design": [
          /* -------------------- Defining -------------------- */
          {
            "value": "empathize_with_users",
            "label": "Empathize with potential users to find issues and uncover needs and potential design opportunities"
          },
          {
            "value": "choose_design_opportunity",
            "label": "Choose a design opportunity"
          },
          {
            "value": "identify_key_features_users",
            "label": "Identify key features or potential users and their requirements"
          },
          {
            "value": "identify_criteria_constraints",
            "label": "Identify criteria for success and any constraints"
          },

          /* -------------------- Ideating -------------------- */
          {
            "value": "generate_potential_ideas",
            "label": "Generate potential ideas and add to others’ ideas"
          },
          {
            "value": "screen_ideas_criteria_constraints",
            "label": "Screen ideas against criteria and constraints"
          },
          {
            "value": "evaluate_impacts_ethics",
            "label": "Evaluate personal, social, and environmental impacts and ethical considerations"
          },
          {
            "value": "choose_idea_to_pursue",
            "label": "Choose an idea to pursue"
          },
          {
            "value": "identify_use_information_sources",
            "label": "Identify and use sources of information"
          },

          /* -------------------- Prototyping -------------------- */
          {
            "value": "develop_plan_stages_resources",
            "label": "Develop a plan that identifies key stages and resources"
          },
          {
            "value": "explore_test_materials",
            "label": "Explore and test a variety of materials for effective use"
          },
          {
            "value": "construct_first_version",
            "label": "Construct a first version of the product or a prototype, making changes as needed"
          },
          {
            "value": "record_iterations",
            "label": "Record iterations of prototyping"
          },

          /* -------------------- Testing -------------------- */
          {
            "value": "test_first_version",
            "label": "Test the first version of the product or prototype"
          },
          {
            "value": "gather_peer_user_expert_feedback",
            "label": "Gather peer, user, and/or expert feedback and inspiration"
          },
          {
            "value": "make_changes_troubleshoot_test",
            "label": "Make changes, troubleshoot, and test again"
          },

          /* -------------------- Making -------------------- */
          {
            "value": "identify_use_tools_materials",
            "label": "Identify and use appropriate tools, technologies, and materials for production"
          },
          {
            "value": "make_production_plan",
            "label": "Make a plan for production that includes key stages, and carry it out, making changes as needed"
          },
          {
            "value": "minimize_waste",
            "label": "Use materials in ways that minimize waste"
          },

          /* -------------------- Sharing -------------------- */
          {
            "value": "decide_sharing",
            "label": "Decide on how and with whom to share their product"
          },
          {
            "value": "demonstrate_product_process",
            "label": "Demonstrate their product and describe their process using appropriate terminology and providing reasons for their selected solution and modifications"
          },
          {
            "value": "evaluate_against_criteria",
            "label": "Evaluate their product against their criteria and explain how it contributes to the individual, family, community, and/or environment"
          },
          {
            "value": "reflect_design_thinking_process",
            "label": "Reflect on their design thinking and processes, and evaluate their ability to work effectively both as individuals and collaboratively in a group, including maintaining an efficient co-operative workspace"
          },
          {
            "value": "identify_new_design_issues",
            "label": "Identify new design issues"
          }
        ],

        /* -------------------- Applied Skills -------------------- */
        "applied_skills": [
          {
            "value": "awareness_safety_procedures",
            "label": "Demonstrate an awareness of precautionary and emergency safety procedures in both physical and digital environments"
          },
          {
            "value": "identify_evaluate_skills",
            "label": "Identify and evaluate the skills and skill levels needed, individually or as a group, in relation to a specific task, and develop them as needed"
          }
        ],

        /* -------------------- Applied Technologies -------------------- */
        "applied_technologies": [
          {
            "value": "select_learn_technologies",
            "label": "Select, and as needed learn about, appropriate tools and technologies to extend their capability to complete a task"
          },
          {
            "value": "identify_impacts_of_technology",
            "label": "Identify the personal, social, and environmental impacts, including unintended negative consequences, of the choices they make about technology use"
          },
          {
            "value": "identify_land_resource_culture_influence",
            "label": "Identify how the land, natural resources, and culture influence the development and use of tools and technologies"
          }
        ]
      }
    }
  }

,
  career_education_8: {
        label: 'Career Education (Grade 8)',
        topics: [],
        competencies: {
          core: [
            { value: 'examine', label: 'Examine' },
            { value: 'interact', label: 'Interact' },
            { value: 'experience', label: 'Experience' },
            { value: 'initiate', label: 'Initiate' },
            { value: 'share', label: 'Share' }
          ],
          sub: {
            examine: [
              { value: 'use_self_assessment_and_reflection', label: 'Use self-assessment and reflection to develop awareness of their strengths, preferences, and skills' },
              { value: 'recognize_the_impact_of_personal_public_identity', label: 'Recognize the impact of personal public identity in the world of work' },
              { value: 'question_self_and_others_about_how_individual_purposes', label: 'Question self and others about how individual purposes and passions can support the needs of the local and global community when considering career choices' }
            ],
            interact: [
              { value: 'demonstrate_respect_collaboration_and_inclusivity', label: 'Demonstrate respect, collaboration, and inclusivity in working with others to solve problems' },
              { value: 'question_self_and_others_about_the_role_of_family_expectations', label: 'Question self and others about the role of family expectations and traditions, and of community needs in career choices' }
            ],
            experience: [
              { value: 'explore_volunteer_and_other_new_learning_experiences', label: 'Explore volunteer and other new learning experiences that stimulate entrepreneurial and innovative thinking' },
              { value: 'apply_decision_making_strategies', label: 'Apply decision-making strategies to a life, work, or community problem and adjust the strategies to adapt to new situations' }
            ],
            initiate: [
              { value: 'recognize_the_influence_of_curriculum_choices', label: 'Recognize the influence of curriculum choices and co-curricular activities on career paths' },
              { value: 'set_and_achieve_realistic_learning_goals', label: 'Set and achieve realistic learning goals with perseverance and resilience' },
              { value: 'apply_a_variety_of_research_skills', label: 'Apply a variety of research skills to expand their knowledge of diverse career possibilities and understand career clusters' }
            ],
            share: [
              { value: 'demonstrate_safety_skills_and_appreciate_the_importance_of_workplace_safety', label: 'Demonstrate safety skills and appreciate the importance of workplace safety' },
              { value: 'appreciate_the_value_of_a_network_of_resources', label: 'Appreciate the value of a network of resources and mentors to assist with career exploration' },
              { value: 'recognize_and_explore_diverse_perspectives', label: 'Recognize and explore diverse perspectives on how work contributes to our community and society' }
            ]
          }
        }
      },        
  "arts_8": {
    "label": "Arts Education (Grade 8)",
    topics: [
        { value: "Expanding and Creating", label: "Expanding and Creating" },
        { value: "reasoning_reflecting", label: "Reasoning and Reflecting" },
        { value: "communicating_documenting", label: "Communicating and Documenting" },
        // { value: "connecting_expanding", label: "Connecting and Expanding" }
      ],
      competencies: {
        core: [
          { value: "Exploring", label: "Expanding and Creating" },
          { value: "Reasoning", label: "Reasoning and Reflecting" },
          { value: "Communicating", label: "Communicating and Documenting" },
          // { value: "Connecting", label: "Connecting and Expanding" }
        ],

      "sub": {
        "exploring_creating": [
          {
            "value": "select_apply_elements_grade8",
            "label": "Intentionally select and apply materials, movements, technologies, environments, tools, and techniques by combining and arranging artistic elements, processes, and principles in art making"
          },
          {
            "value": "create_artistic_works_grade8",
            "label": "Create artistic works collaboratively and as an individual using ideas inspired by imagination, inquiry, experimentation, and purposeful play"
          },
          {
            "value": "explore_identity_place_culture_society_grade8",
            "label": "Explore relationships between identity, place, culture, society, and belonging through arts activities and experiences"
          }
        ],

        "reasoning_reflecting": [
          {
            "value": "describe_evaluate_artists_grade8",
            "label": "Describe, interpret, and evaluate how artists use processes, materials, movements, technologies, tools, techniques, and environments to create and communicate ideas"
          },
          {
            "value": "develop_refine_critique_grade8",
            "label": "Develop and refine ideas, and critically appraise ideas, processes, and technical skills in a variety of art forms to improve the quality of artistic creations"
          },
          {
            "value": "reflect_understand_motivations_grade8",
            "label": "Reflect on works of art and creative processes to understand artists’ motivations and meanings"
          },
          {
            "value": "understand_appreciate_contexts_grade8",
            "label": "Demonstrate an understanding and appreciation of personal, social, cultural, historical, and environmental contexts in relation to the arts"
          },
          {
            "value": "interpret_using_other_learning_grade8",
            "label": "Interpret works of art using knowledge and skills from various areas of learning"
          }
        ],

        "communicating_documenting": [
          {
            "value": "interpret_communicate_symbols_grade8",
            "label": "Interpret and communicate ideas using symbols and elements to express meaning through the arts"
          },
          {
            "value": "take_creative_risks_grade8",
            "label": "Take creative risks to express feelings, ideas, and experiences"
          },
          {
            "value": "describe_interpret_respond_art_grade8",
            "label": "Describe, interpret, and respond to works of art"
          },
          {
            "value": "experience_document_perform_share_grade8",
            "label": "Experience, document, choreograph, perform, and share creative works in a variety of ways"
          }
        ],

        "connecting_expanding": [
          {
            "value": "respond_using_world_knowledge_grade8",
            "label": "Respond to works of art using one’s knowledge of the world"
          },
          {
            "value": "use_arts_global_environmental_grade8",
            "label": "Use the arts to communicate, respond to, and understand environmental and global issues"
          },
          {
            "value": "demonstrate_sophisticated_application_grade8",
            "label": "Demonstrate increasingly sophisticated application and/or engagement of curricular content"
          }
        ]
      }
    }
  },

      "english_8": {
    "label": "English Language Arts (Grade 8)",
    "topics": [
      { "value": "comprehend_connect", "label": "Comprehend and Connect (Reading, Listening, Viewing)" },
      { "value": "create_communicate", "label": "Create and Communicate (Writing, Speaking, Representing)" }
    ],
    "competencies": {
      "core": [
        { "value": "comprehend_connect", "label": "Comprehend and Connect (reading, listening, viewing)" },
        { "value": "create_communicate", "label": "Create and Communicate (writing, speaking, representing)" }
      ],
      "sub": {
        "comprehend_connect": [
          {
            "value": "access_info_evaluate",
            "label": "Access information and ideas for diverse purposes from a variety of sources and evaluate their relevance, accuracy, and reliability (Grade 6–9)"
          },
          {
            "value": "apply_strategies_comprehend",
            "label": "Apply appropriate strategies to comprehend written, oral, and visual texts, guide inquiry, and extend thinking (Grade 6–9)"
          },
          {
            "value": "synthesize_ideas_sources",
            "label": "Synthesize ideas from a variety of sources to build understanding (Grade 5–9)"
          },
          {
            "value": "recognize_text_features_genres",
            "label": "Recognize and appreciate how different features, forms, and genres of texts reflect different purposes, audiences, and messages (Grade 6–9)"
          },
          {
            "value": "think_critically_creatively",
            "label": "Think critically, creatively, and reflectively to explore ideas within, between, and beyond texts (Grade 6–9)"
          },
          {
            "value": "identify_personal_social_cultural_context",
            "label": "Recognize and identify the role of personal, social, and cultural contexts, values, and perspectives in texts (Grade 6–9)"
          },
          {
            "value": "recognize_language_identity",
            "label": "Recognize how language constructs personal, social, and cultural identity (Grade 6–9)"
          },
          {
            "value": "construct_personal_connections",
            "label": "Construct meaningful personal connections between self, text, and world (Grade 6–9)"
          },
          {
            "value": "respond_text_personal_creative_critical",
            "label": "Respond to text in personal, creative, and critical ways (Grade 6–9)"
          },
          {
            "value": "explain_literary_elements_devices",
            "label": "Understand or explain how literary elements, techniques, and devices enhance and shape meaning (Grade 6–9)"
          },
          {
            "value": "recognize_text_structures",
            "label": "Recognize an increasing range of text structures and how they contribute to meaning (Grade 6–9)"
          },
          {
            "value": "appreciate_fp_story_role",
            "label": "Recognize and appreciate the role of story, narrative, and oral tradition in expressing First Peoples perspectives, values, beliefs, and points of view (Grade 6–9)"
          },
          {
            "value": "fp_protocols_ownership",
            "label": "Develop an awareness of the protocols, ownership, and diversity within and across First Peoples texts (Grade 8–9)"
          },
          {
            "value": "influence_of_place_texts",
            "label": "Recognize the influence of place in First Peoples and other Canadian texts (Grade 6–9)"
          }
        ],

        "create_communicate": [
          {
            "value": "exchange_ideas_viewpoints",
            "label": "Exchange ideas and viewpoints to build shared understanding and extend thinking (Grade 6–9)"
          },
          {
            "value": "writing_design_processes_6_9",
            "label": "Use writing and design processes to plan, develop, and create engaging and meaningful literary and informational texts for a variety of purposes and audiences (Grade 6–9)"
          },
          {
            "value": "assess_refine_texts",
            "label": "Assess and refine texts to improve their clarity, effectiveness, and impact according to purpose, audience, and message (Grade 6–9)"
          },
          {
            "value": "use_canadian_conventions",
            "label": "Use an increasing repertoire of conventions of Canadian spelling, grammar, and punctuation (Grade 6–9)"
          },
          {
            "value": "oral_storytelling_processes",
            "label": "Use and experiment with oral storytelling processes (Grade 6–9)"
          },
          {
            "value": "select_features_forms_genres",
            "label": "Select and use appropriate features, forms, and genres according to audience, purpose, and message (Grade 6–9)"
          },
          {
            "value": "transform_ideas_original_texts",
            "label": "Transform ideas and information to create original texts (Grade 4–9)"
          },
          {
            "value": "express_opinion_support_evidence",
            "label": "Express an opinion and support it with credible evidence (Grade 9 emphasis)"
          }
        ]
      }
    }
  }, 
  
  
   "math_8": {
  "label": "Mathematics (Grade 8)",
"topics": [
      { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
      { "value": "understanding_solving", "label": "Understanding and Solving" },
      { "value": "communicating_representing", "label": "Communicating and Representing" },
      { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
    ],

    "competencies": {
      "core": [
        { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
        { "value": "understanding_solving", "label": "Understanding and Solving" },
        { "value": "communicating_representing", "label": "Communicating and Representing" },
        { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
      ],

      "sub": {
        "reasoning_analyzing": [
          {
            "value": "use_logic_patterns_solve_puzzles_6_9",
            "label": "Use logic and patterns to solve puzzles and play games"
          },
          {
            "value": "reason_analyze_apply_math_ideas_6_9",
            "label": "Use reasoning and logic to explore, analyze, and apply mathematical ideas"
          },
          {
            "value": "estimate_reasonably_6_9",
            "label": "Estimate reasonably"
          },
          {
            "value": "mental_math_strategies_6_9",
            "label": "Demonstrate and apply mental math strategies"
          },
          {
            "value": "use_tools_technology_patterns_6_9",
            "label": "Use tools or technology to explore and create patterns and relationships, and test conjectures"
          }
        ],

        "understanding_solving": [
          {
            "value": "model_mathematics_context_6_9",
            "label": "Model mathematics in contextualized experiences"
          },
          {
            "value": "apply_multiple_problem_solving_strategies_6_9",
            "label": "Apply multiple strategies to solve problems in both abstract and contextualized situations"
          },
          {
            "value": "demonstrate_math_understanding_6_9",
            "label": "Develop, demonstrate, and apply mathematical understanding through play, inquiry, and problem solving"
          },
          {
            "value": "visualize_explore_math_concepts_6_9",
            "label": "Visualize to explore mathematical concepts"
          },
          {
            "value": "problem_solving_local_culture_6_9",
            "label": "Engage in problem-solving experiences connected to place, story, cultural practices, and perspectives relevant to local First Peoples communities, the local community, and other cultures"
          }
        ],

        "communicating_representing": [
          {
            "value": "use_math_vocabulary_discussions_6_9",
            "label": "Use mathematical vocabulary and language to contribute to mathematical discussions"
          },
          {
            "value": "explain_justify_math_ideas_6_9",
            "label": "Explain and justify mathematical ideas and decisions"
          },
          {
            "value": "communicate_math_thinking_6_9",
            "label": "Communicate mathematical thinking in many ways"
          },
          {
            "value": "represent_math_ideas_6_9",
            "label": "Represent mathematical ideas in concrete, pictorial, and symbolic forms"
          }
        ],

        "connecting_reflecting": [
          {
            "value": "reflect_math_thinking_6_9",
            "label": "Reflect on mathematical thinking"
          },
          {
            "value": "connect_math_concepts_6_9",
            "label": "Connect mathematical concepts to each other and to other areas and personal interests"
          },
          {
            "value": "use_math_arguments_support_choices_6_9",
            "label": "Use mathematical arguments to support personal choices"
          },
          {
            "value": "incorporate_first_peoples_perspectives_6_9",
            "label": "Incorporate First Peoples worldviews and perspectives to make connections to mathematical concepts"
          }
        ]
      }
    }
  }
,
 "phe_8": {
    "label": "Physical and Health Education (Grade 8)",
   "topics": [
      { "value": "physical_literacy", "label": "Physical Literacy" },
      { "value": "healthy_active_living", "label": "Healthy and Active Living" },
      { "value": "social_community_health", "label": "Social and Community Health" },
      { "value": "mental_well_being", "label": "Mental Well-Being" }
    ],

    "competencies": {
      "core": [
        { "value": "physical_literacy", "label": "Physical Literacy" },
        { "value": "healthy_active_living", "label": "Healthy and Active Living" },
        { "value": "social_community_health", "label": "Social and Community Health" },
        { "value": "mental_well_being", "label": "Mental Well-Being" }
      ],

      "sub": {
        "physical_literacy": [
          {
            "value": "refine_apply_movement_skills_8",
            "label": "Refine and apply fundamental movement skills in a variety of physical activities and environments (8–9)"
          },
          {
            "value": "apply_movement_concepts_strategies_8",
            "label": "Apply movement concepts and strategies in different physical activities (3–8)"
          },
          {
            "value": "safety_fair_play_leadership_8",
            "label": "Develop and demonstrate safety, fair play, and leadership in physical activities (K–9)"
          },
          {
            "value": "identify_preferred_activities_8",
            "label": "Identify and describe preferred types of physical activity (4–9)"
          },
          {
            "value": "analyze_personal_habits_8",
            "label": "Analyze strategies for developing and maintaining positive personal habits"
          }
        ],

        "healthy_active_living": [
          {
            "value": "participate_daily_activity_8",
            "label": "Participate daily in physical activity at moderate to vigorous intensity levels (K–9)"
          },
          {
            "value": "healthy_eating_strategies_8",
            "label": "Describe strategies for making healthy eating choices (6–8)"
          },
          {
            "value": "personal_healthy_living_goals_8",
            "label": "Describe strategies for pursuing personal healthy-living goals (6–9)"
          },
          {
            "value": "factors_influencing_healthy_choices_8",
            "label": "Describe factors influencing personal healthy-living choices (6–8)"
          },
          {
            "value": "healthy_relationships_strategies_8",
            "label": "Identify and apply strategies for developing healthy relationships (8–9)"
          }
        ],

        "social_community_health": [
          {
            "value": "discrimination_stereotyping_bullying_8",
            "label": "Demonstrate strategies for responding to discrimination, stereotyping, and bullying (8–9)"
          },
          {
            "value": "outdoor_activities_community_connection_8",
            "label": "Explain how participation in outdoor activities supports connections with community and environment (8–9)"
          },
          {
            "value": "leadership_collaboration_8",
            "label": "Demonstrate leadership and collaboration in creating positive, safe, and caring environments"
          }
        ],

        "mental_well_being": [
          {
            "value": "strategies_promote_mental_wellbeing_8",
            "label": "Describe and assess strategies for promoting mental well-being (6–8)"
          },
          {
            "value": "manage_mental_wellbeing_substance_8",
            "label": "Apply strategies for managing problems related to mental well-being and substance use (6–9)"
          },
          {
            "value": "factors_influencing_self_identity_8",
            "label": "Describe factors influencing self-identity (8–9)"
          },
          {
            "value": "manage_life_changes_transitions_8",
            "label": "Apply personal strategies to manage life changes and transitions"
          }
        ]
      }
    }
  },


 
      science_8: {
        label: "Science (Grade 8)",
        topics: [
          { value: "cells_tissues", label: "Cells and Tissues" },
          { value: "energy_transfer", label: "Energy Transfer" },
          { value: "earth_processes", label: "Earth Processes" }
        ],
        competencies: {
          core: [
            { value: "questioning_predicting", label: "Questioning and Predicting" },
            { value: "planning_conducting", label: "Planning and Conducting" },
            { value: "processing_analyzing", label: "Processing and Analyzing Data and Information" },
            { value: "evaluating", label: "Evaluating" },
            { value: "applying_innovating", label: "Applying and Innovating" },
            { value: "communicating", label: "Communicating" }
          ],
          sub: {
            questioning_predicting: [
              { value: "intellectual_curiosity", label: "Demonstrate sustained intellectual curiosity about a scientific topic or problem of personal interest" },
              { value: "observations_form_questions", label: "Make observations aimed at identifying their own questions about the natural world" },
              { value: "alternative_hypotheses", label: "Formulate alternative “If…then…” hypotheses" },
              { value: "predict_findings", label: "Make predictions about findings" }
            ],

            planning_conducting: [
              { value: "collaborative_planning", label: "Collaboratively plan a range of investigation types, including field work and experiments" },
              { value: "measure_control_variables", label: "Measure and control variables (dependent and independent) through fair tests" },
              { value: "record_accurate_data", label: "Observe, measure, and record data (qualitative and quantitative) accurately" },
              { value: "use_SI_units", label: "Use appropriate SI units and perform simple conversions" },
              { value: "follow_safety_ethics", label: "Ensure that safety and ethical guidelines are followed" }
            ],

            processing_analyzing: [
              { value: "first_peoples_perspectives", label: "Apply First Peoples perspectives and local knowledge as sources of information" },
              { value: "represent_patterns", label: "Construct and use tables, graphs, models, and digital technologies to represent patterns" },
              { value: "seek_patterns_connections", label: "Seek patterns and connections in data" },
              { value: "scientific_relationships", label: "Use scientific understandings to identify relationships and draw conclusions" }
            ],

            evaluating: [
              { value: "reflect_methods", label: "Reflect on investigation methods and quality of data" },
              { value: "identify_sources_error", label: "Identify possible sources of error and suggest improvements" },
              { value: "assumptions_bias", label: "Demonstrate awareness of assumptions and bias" },
              { value: "evaluate_secondary_claims", label: "Exercise healthy, informed skepticism and evaluate claims in secondary sources" },
              { value: "social_ethical_environmental", label: "Consider social, ethical, and environmental implications" }
            ],

            applying_innovating: [
              { value: "care_self_community_world", label: "Contribute to care for self, others, community, and world through personal or collaborative approaches" },
              { value: "cooperative_design", label: "Co-operatively design projects" },
              { value: "apply_learning", label: "Transfer and apply learning to new situations" },
              { value: "generate_new_ideas", label: "Generate and introduce new or refined ideas when problem solving" }
            ],

            communicating: [
              { value: "communicate_scientific_language", label: "Communicate ideas, findings, and solutions using scientific language and digital tools" },
              { value: "express_reflect_place", label: "Express and reflect on a variety of experiences and perspectives of place" }
            ]
          }
        }
      },
      core_french_8: {
        label: 'Core French',
        topics: [],
        competencies: {
          core: [
            { value: 'thinking_and_communicating', label: 'Thinking and Communicating' },
            { value: 'personal_and_social_awareness', label: 'Personal and Social Awareness' }
          ],
          sub: {
            thinking_and_communicating: [
              { value: 'recognize_letter_patterns_pronunciation', label: 'Recognize the relationships between French letter patterns and pronunciation' },
              { value: 'comprehend_key_information_supporting_details_texts', label: 'Comprehend key information and supporting details in texts' },
              { value: "use_various_strategies", label: "Use various strategies to support communication" },
              { value: "seek_clarification", label: "Seek clarification of meaning" },
              { value: 'exchange_ideas_information', label: 'Exchange ideas and information using complete sentences, both orally and in writing' },
              { value: 'comprehend_retell_stories', label: 'Comprehend and retell stories' },
              { value: 'narrate_simple_stories', label: 'Narrate simple stories' }
            ],
            personal_and_social_awareness: [
              { value: 'explore_share_info_francophone_communities_worldwide', label: 'Explore and share information about Francophone communities around the world' },
              { value: 'explore_share_info_connections_indigenous', label: 'Explore and share information about connections between Indigenous communities and the French language' },
              { value: 'explore_francophone_cultures_creative_works', label: 'Explore ways in which Francophone cultures are expressed through creative works' },
              { value: 'describe_cultural_aspects_francophone_communities', label: 'Describe cultural aspects of Francophone communities' },
              { value: 'engage_in_experiences_francophone_communities', label: 'Explore ways to engage in experiences with Francophone communities and people' }
            ]
          }
        }
      },
      
    

      
  "social_studies_8": {
    "label": "Social Studies (Grade 8)",
  "topics": [
      { "value": "inquiry", "label": "Inquiry" },
      { "value": "significance", "label": "Significance" },
      { "value": "evidence", "label": "Evidence" },
      { "value": "continuity_change", "label": "Continuity and Change" },
      { "value": "cause_consequence", "label": "Cause and Consequence" },
      { "value": "perspective", "label": "Perspective" },
      { "value": "ethical_judgement", "label": "Ethical Judgement" }
    ],

    "competencies": {
      "core": [
        { "value": "inquiry", "label": "Inquiry" },
        { "value": "significance", "label": "Significance" },
        { "value": "evidence", "label": "Evidence" },
        { "value": "continuity_change", "label": "Continuity and Change" },
        { "value": "cause_consequence", "label": "Cause and Consequence" },
        { "value": "perspective", "label": "Perspective" },
        { "value": "ethical_judgement", "label": "Ethical Judgement" }
      ],
      "sub": {
        "inquiry": [
          {
            "value": "inquiry_process_ss7_8",
            "label": "Use Social Studies inquiry processes and skills to ask questions; gather, interpret, and analyze ideas; and communicate findings and decisions"
          }
        ],

        "significance": [
          {
            "value": "assess_significance_ss7_8",
            "label": "Assess the significance of people, places, events, or developments at particular times and places"
          },
          {
            "value": "identify_creators_significance_ss7_8",
            "label": "Identify what the creators of accounts, narratives, maps, or texts have determined is significant"
          }
        ],

        "evidence": [
          {
            "value": "assess_credibility_sources_ss7_8",
            "label": "Assess the credibility of multiple sources and the adequacy of evidence used to justify conclusions"
          }
        ],

        "continuity_change": [
          {
            "value": "characterize_time_periods_ss7_8",
            "label": "Characterize different time periods in history, including periods of progress and decline, and identify key turning points that marked periods of change"
          }
        ],

        "cause_consequence": [
          {
            "value": "determine_causes_consequences_ss7_8",
            "label": "Determine which causes most influenced particular decisions, actions, or events, and assess their short- and long-term consequences"
          }
        ],

        "perspective": [
          {
            "value": "explain_compare_perspectives_ss7_8",
            "label": "Explain different perspectives on past or present people, places, issues, or events, and compare the values, worldviews, and beliefs of human cultures and societies in different times and places"
          }
        ],

        "ethical_judgement": [
          {
            "value": "make_ethical_judgments_past_ss7_8",
            "label": "Make ethical judgments about past events, decisions, or actions, and assess the limitations of drawing direct lessons from the past"
          }
        ]
      }
    }
  
},

 


    }
  }
    export default grade_8;